import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ContainerTapService } from '../services/container-tap/container-tap.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-row-link-tap',
  template: `
    <ng-container *ngIf="params.data[params.colDef.field] === 'TAP'; else plainValue">
      <div (click)="openDialog()">
        <span class="hyperlink">{{params.data[params.colDef.field]}}</span>
      </div>
    </ng-container>
    <ng-template #plainValue>
      <div class="span-cell">
        <span class="span-cell">{{ params.data[params.colDef.field] }}</span>
      </div>
    </ng-template>
  `,
  styles: [`
    .hyperlink {
      cursor: pointer;
      color: #2688DA;
      text-decoration: underline;
    }
    .span-cell {
      margin-left: 0rem;      
    }
  `]
})
export class RowLinkTapComponent implements ICellRendererAngularComp {
  public params: any;
  modalComponent = 'modal-component';
  namcValue = localStorage.getItem('namcvalue');
  userName = localStorage.getItem('UserName');
  userRole = localStorage.getItem('UserRoles');
  user = localStorage.getItem('workdayId');

  constructor(
    private readonly dialog: MatDialog,
    private readonly containerTapService: ContainerTapService,
    private readonly spinner: NgxSpinnerService
  ) {}

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: any): boolean {
    return false;
  }

  openDialog(){
    this.params.context.componentParent.userTapped(
      this.params.node.rowIndex
    );
  }
}
